import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  companyPortalOrHttpUrlValidator,
  optionalEmailValidator,
  linkOrEmptyValidator,
  requiredIfFieldHasText,
} from 'src/app/shared/validators/form-validators';
import { ContactType, RelationshipType } from 'src/app/features/tooling/models/tool-form-types';

export type ResourceUrlForm = {
  title: FormControl<string>;
  url: FormControl<string>;
  description: FormControl<string>;
};

export type AlternativeToolForm = {
  relatedToolId: FormControl<number | null>;
  relationshipType: FormControl<RelationshipType>;
};

export type ToolContactForm = {
  type: FormControl<ContactType>;
  name: FormControl<string>;
  contactDetail: FormControl<string>;
  isFromCmdb: FormControl<boolean>;
};

export function createDocumentationLinkGroup(fb: FormBuilder): FormGroup<ResourceUrlForm> {
  const group = fb.group<ResourceUrlForm>({
    title: fb.nonNullable.control('', [Validators.maxLength(200), requiredIfFieldHasText(['url', 'description'], 'titleRequired')]),
    url: fb.nonNullable.control('', [companyPortalOrHttpUrlValidator(), requiredIfFieldHasText(['title', 'description'], 'urlRequired')]),
    description: fb.nonNullable.control('', [Validators.maxLength(500)]),
  });

  return group;
}

export function createAlternativeToolGroup(fb: FormBuilder): FormGroup<AlternativeToolForm> {
  const group = fb.group<AlternativeToolForm>({
    relatedToolId: fb.nonNullable.control<number | null>(null),
    relationshipType: fb.nonNullable.control<RelationshipType>('Alternative', [Validators.required]),
  });

  return group;
}

export function createContactGroup(fb: FormBuilder): FormGroup<ToolContactForm> {
  const group = fb.group<ToolContactForm>({
    type: fb.nonNullable.control<ContactType>(ContactType.Owner, [Validators.required]),
    name: fb.nonNullable.control('', [Validators.maxLength(200), requiredIfFieldHasText('contactDetail', 'nameRequired')]),
    contactDetail: fb.nonNullable.control(''),
    isFromCmdb: fb.nonNullable.control(false),
  });

  applyContactDetailValidators(group);
  return group;
}

export function applyContactDetailValidators(group: FormGroup<ToolContactForm>): void {
  const type = group.controls.type.value;
  const ctrl = group.controls.contactDetail;
  ctrl.clearValidators();

  if (type === ContactType.SupportLink) {
    ctrl.addValidators([linkOrEmptyValidator(), requiredIfFieldHasText('name', 'linkRequired')]);
  } else {
    ctrl.addValidators([optionalEmailValidator()]);
  }

  ctrl.updateValueAndValidity();
  group.updateValueAndValidity({ onlySelf: true });
}